<!-- Translated: yes -->
<template>
  <div :class="{'the-banner': true, 'auto-pay': $route.query.pay}">
    <div class="container">
      <div style="text-align:center;">

        <Timeline :show-time-line="cart.accomodations.filter(function(a) {return a.confirmed;}).length" :steps="timelineSteps"></Timeline>

      </div>
    </div>

    <div class="bg-color-faded">
      <div class="container">

        <div class="optional-booking min-tablet" v-if="!$store.state.cart.addToOrder || !$store.state.cart.addToOrder.accomodationRow">
          <h1>{{ $t('general.make-it-easier') }}</h1>
          <CompletedBookings style="margin-top:0;" />
        </div>


        <h1>{{ $t('general.your-cart') }}</h1>

        <Cart :show-from-start="true" />

        <div v-if="$store.state.cart.addToOrder && $store.state.cart.addToOrder.number" class="appending-info">

          <p>{{ $t('general.when-you-click', {number: ''}) }} <router-link :to="{name: 'my booking', params: {bookingNumber: $store.state.cart.addToOrder.numeric} }">{{$store.state.cart.addToOrder.number}}</router-link><span v-if="$store.state.cart.addToOrder.dateStart"> ({{ [$store.state.cart.addToOrder.dateStart, $store.state.cart.addToOrder.dateEnd] | dateRange }})</span>.</p>

          <p v-if="$store.state.cart.addToOrder.accomodationRow">Bokningen kommer att kopplas till boendet <b>{{$store.state.cart.addToOrder.accomodationName}}</b> ({{ [$store.state.cart.addToOrder.accomodationDateArrival, $store.state.cart.addToOrder.accomodationDateDeparture] | dateRange }}).</p>

          <p>{{ $t('general.new-order', {clickhere: ''}) }}<a href="javascript:void(0)" @click="removeOrderLink()">{{ $t('general.clickhere') }}</a>.</p>

        </div>

        <div class="optional-booking max-mobile" style="margin-top: 30px;" v-if="!$store.state.cart.addToOrder || !$store.state.cart.addToOrder.accomodationRow">
          <h1>{{ $t('general.make-it-easier') }}</h1>
          <CompletedBookings style="margin-top:0;" />
        </div>

      </div>
    </div>
    <div class="bg-color-faded related-orders">
      <div class="container">
        <div v-if="openRelatedOrders.length" class="appending-info" style="margin-top:0;">
          <p>Det finns en annan tilläggsbokning som inte har betalats. Avbryt den innan du går vidare.</p>
          <table class="order-table">
            <tr v-for="(order, index) in openRelatedOrders">
              <td>
                {{ order.created_at | date('short-with-time') }}
              </td>
              <td>
                {{ order.sum | currency }}
              </td>
              <!-- <td>
                <a :class="'button small' + (order.vue_working_status ? ' disabled' : '')" v-if="order.checkout_session_id" href="javascript:void(0)" @click="continueOrder(index)">Fortsätt</a>
              </td> -->
              <td>
                <a :class="'button small' + (order.vue_working_status ? ' disabled' : '')" href="javascript:void(0)" @click="cancelOrder(index)">Avbryt</a>
              </td>
              <td>
                <span v-if="order.vue_working_status">Avbryter...</span>
              </td>
            </tr>
          </table>
        </div>
      </div>
    </div>

    <div class="bg-color-faded" v-if="showTryPayment">
      <div class="container">
        <div class="bottom-buttons-wrapper">
          <div>
            <CheckoutCodeModal />
          </div>
          <div style="text-align:right;" :class="{'disabled': !enableTryPayment}">
            <p>&nbsp;</p>
            <button @click="tryPayment()">{{ $t('general.cta.pay') }} <icon name="arrow-white" :scale="1.5" /></button>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import { mapMutations, mapGetters } from 'vuex';

import Cart from '@/components/parts/Cart';
import Timeline from '@/components/components/Timeline';
import CompletedBookings from '@/components/parts/CompletedBookings';
import CheckoutCodeModal from '@/components/payments/CheckoutCodeModal';

import accomodationTimelineSteps from '@/mixins/accomodationTimelineSteps';
import languageDetector from '@/mixins/languageDetector';

import API from '@/classes/API';

import moment from 'moment';

export default {
  components: {
    Cart,
    Timeline,
    CompletedBookings,
    CheckoutCodeModal,
  },
  mixins: [accomodationTimelineSteps, languageDetector],
  data() {
    return {
      secondsLeft: 0,
      openRelatedOrders: [],
      openRelatedOrdersLoaded: false,
    };
  },
  computed: {
    ...mapGetters([
      'loggedIn',
      'cart',
    ]),
    isCartEmpty() {
      const products = [
        'accomodations',
        'addons',
        'rentals',
        'skipasses',
        'skischools',
        'products',
      ];

      return products.every(this.isProductNotInCart);
    },
    canUseCode() {
      // const skipasses = this.cart.skipasses.filter(a => a.confirmed).length;
      // const skischools = this.cart.skischools.filter(a => a.confirmed).length;

      // const sum = skipasses + skischools;

      // const rentals = this.cart.rentals.filter(a => a.confirmed);

      // let okay = !sum;

      // rentals.forEach((rental) => {
      //   if (rental.delivery) {
      //     okay = false;
      //   }
      // });

      // return okay;
      return !this.isCartEmpty;
    },
    language() {
      return this.browserLanguage;
    },
    country() {
      return this.browserCountry;
    },
    showTryPayment() {
      return !this.isCartEmpty;
    },
    enableTryPayment() {
      const isAddToOrder = this.$store.state.cart.addToOrder
        && this.$store.state.cart.addToOrder.numeric;

      if (this.$store.state.cart.codeRequiresExtraInfo && !this.$store.state.cart.codeExtraInfo) {
        return false;
      }

      if (!isAddToOrder) {
        return true;
      }

      return this.openRelatedOrders.length === 0 && this.openRelatedOrdersLoaded;
    },
  },
  mounted() {
    if (this.$route.query['show-confirmation']) {
      if (this.$route.query.ref === 'accomodation') {
        const accomodations = this.$store.state.cart.accomodations;
        let currentWinter = true;

        if (accomodations.length) {
          const arrival = accomodations[0].period.date_arrival;
          const winterDates = this.SITE_CONFIG.season.winter;

          currentWinter = false;

          if (arrival >= winterDates.start && arrival <= winterDates.end) {
            currentWinter = true;
          }
        }

        // Only show special accomodation modal in current winter season
        const isAddTo = this.$store.state.cart.addToOrder
          && this.$store.state.cart.addToOrder.numeric;
        if (currentWinter && this.SITE_CONFIG.modules_open.skiletting.open && !isAddTo) {
          this.$nextTick(() => {
            this.openModal(['CartHighFiveAccomodationModal', {
              ref: this.$route.query.ref,
              text: this.$route.query.text,
            }]);
          });
        } else {
          this.$nextTick(() => {
            this.openModal(['CartHighFiveModal', {
              ref: this.$route.query.ref,
              text: this.$route.query.text,
            }]);
          });
        }
      } else {
        this.$nextTick(() => {
          this.openModal(['CartHighFiveModal', {
            ref: this.$route.query.ref,
            text: this.$route.query.text,
          }]);
        });
      }
    }
    if (this.$route.query.pay) {
      this.$nextTick(() => {
        this.goToPayment();
      });
    }

    const isAddToOrder = this.$store.state.cart.addToOrder
      && this.$store.state.cart.addToOrder.numeric;

    if (isAddToOrder) {
      API.get(`/orders/open-addon-orders/${this.$store.state.cart.addToOrder.numeric}`).then((response) => {
        this.openRelatedOrders = response.data;
        this.openRelatedOrdersLoaded = true;
      });
    }

    this.trackCart();
  },
  methods: {
    ...mapMutations([
      'openModal',
      'closeModal',
    ]),
    removeOrderLink() {
      const $this = this;
      this.openModal(['GeneralModal', {
        content: this.$i18n.t('general.remove-order-connection-text'),
        buttons: [
          {
            title: this.$i18n.t('general.remove-order-connection-title'),
            class: 'small',
            click: () => {
              $this.$store.state.cart.deliveryTo = {};
              /*eslint-disable */
              for (let i in $this.$store.state.cart.rentals) {
                $this.$store.state.cart.rentals[i].delivery = false;
                $this.$store.state.cart.rentals[i].site = null;
              }
              for (let i in $this.$store.state.cart.skipasses) {
                $this.$store.state.cart.skipasses[i].delivery_type = 'pickup';
                $this.$store.state.cart.skipasses[i].deliveryType = 'pickup';
                $this.$store.state.cart.skipasses[i].site = null;
              }
              /*eslint-enable */
              $this.$store.state.cart.addToOrder = {};
              $this.closeModal();
              window.location.reload();
            },
          },
          {
            title: this.$i18n.t('general.go-back'),
            class: 'small white border',
            click: () => {
              $this.closeModal();
            },
          },
        ],
      }]);
    },
    /*eslint-disable */
    async checkAvailability() {
      let fullSuccess = true;

      for (let school of this.$store.state.cart.skischools) {
        let peopleCount = school.people.length;
        let { success } = await API.get(`/skischool/check-availability/${school.activity_lid}/${peopleCount}/${this.$store.state.lockingCode}`);
        if (!success) {
          fullSuccess = false;
        }
      }

      return fullSuccess;
    },
    async reserve() {
      let fullSuccess = true;

      for (let school of this.$store.state.cart.skischools) {
        let peopleCount = school.people.length;
        let { success } = await API.get(`/skischool/reserve/${school.activity_lid}/${peopleCount}/${this.$store.state.lockingCode}`);
        if (!success) {
          fullSuccess = false;
        }
      }

      return fullSuccess;
    },
    /*eslint-enable */
    async createOrderAndRedirect() {
      // todo
      const available = true; // await this.checkAvailability();
      if (available) {
        const reserved = true; // await this.reserve();
        if (reserved) {
          this.openModal(['CreatingOrder']);
        } else {
          this.openModal(['GeneralModal', {
            content: this.$i18n.t('general.reservation-fail'),
          }]);
        }
      } else {
        this.openModal(['GeneralModal', {
          content: this.$i18n.t('general.reservation-fail'),
        }]);
      }
    },
    async trackCart() {
      try {
        const { currency, lines, total } = await API.frontendHelper('/get-cart-for-ga', {
          cart: this.$store.state.cart,
        });

        window.trackViewCart(lines, currency, total);
      } catch (e) {
        console.error(e);
      }
    },
    tryPayment() {
      if (moment.utc(`${this.$store.state.lockingBeforeTime}`, 'YYYY-MM-DD HH:mm:ss').diff(moment(), 'seconds') <= 0) {
        this.openModal(['ReclaimReservationsModal', {
          continueToPayment: this.goToPayment,
        }]);
      } else {
        this.goToPayment();
      }
    },
    goToPayment() {
      this.$store.state.cart.language = this.language;
      this.$store.state.cart.country = this.country;

      // this.$store.state.cart.pincode = '';

      if (this.loggedIn /* || !this.SITE_CONFIG.use_login */) {
        this.createOrderAndRedirect();
      } else {
        this.openModal(['CheckoutLoginModal', {
          goToPayment: this.createOrderAndRedirect,
        }]);
      }
    },
    isProductNotInCart(product) {
      const val = this.cart[product].filter(a => a.confirmed).length;
      return !val;
    },
    // continueOrder(index) {
    //   const order = this.openRelatedOrders[index];

    //   const query = {
    //     order: order.id,
    //     code: order.code,
    //   };

    //   this.$router.push({
    //     name: 'payment',
    //     query,
    //   });
    // },
    cancelOrder(index) {
      const order = this.openRelatedOrders[index];

      this.openRelatedOrders[index].vue_working_status = true;

      API.post(`cancel-order/${order.id}/${order.code}`).then(() => {
        this.openRelatedOrders.splice(index, 1);
      });
    },
  },
};
</script>

<style lang="stylus" scoped>
@import '~@/global.styl'

.disabled
  disabled()

.the-banner
  min-height calc(100vh - 300px)
  background-color #fbfbf8

.the-banner.auto-pay
  height 100vh
  background-size cover
  background-image url(https://static.booking.branasgruppen.se/static/img/onsite-splash.jpg)
  background-position center
  position relative
  padding 0
  & > div
    display: none

body{
  background-color: red
}

.order-table
  td
    padding: 5px
    padding-right: 18px

h1
  //margin-bottom -50px
  text-align left
  text-transform none

.container
  padding-top 10px
  max-width 1116px
  margin-right auto
  margin-left auto
  position relative

  .optional-booking
    position: relative
    button
      margin-left: 0px
  +max-mobile()
    padding-left: 10px
    padding-right: 10px

.bg-color-faded
  padding-top 8px
  padding-bottom 15px
  background-color #fbfbf8

.buttons
  margin-top 0px
  margin-bottom 10px

.appending-info
  border-radius 2px
  background-color rgba(199, 220, 183, 0.26)
  border solid 1px #d1e0c2
  padding 8px 27px
  margin-top: 30px
  margin-bottom: 0px
  p
    margin 7px 0

.related-orders
  .appending-info
    background-color rgba(255, 255, 225, 0.75)
    border-color #ffd900

.campaign-code
  text-align: right

.bottom-buttons-wrapper
  display: flex
  justify-content: space-between
  flex-direction column
  +min-tablet()
    flex-direction column
</style>



// WEBPACK FOOTER //
// ShoppingCartPage.vue?320005da